import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const DdosHero = () => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  return (
    <div className="ddos-hero-wrap">
      <h1 className="ddos-hero-title">
        DDOS <span className="ddos-hero-title-accent">STRESS</span>
      </h1>
      <p className="ddos-hero-subtitle">
        {isEn
          ? 'Analysis of server resilience against common DDoS attack vectors. Connect to the target below to begin. Ensure you have authorized permission before testing.'
          : 'Анализ устойчивости сервера к распространенным векторам DDoS-атак. Подключитесь к цели ниже, чтобы начать. Перед началом убедитесь, что у вас есть разрешение.'}
      </p>
    </div>
  );
};

export default DdosHero;
